/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AvailabilityByProduct
 */
export interface AvailabilityByProduct {
    /**
     * 
     * @type {string}
     * @memberof AvailabilityByProduct
     */
    productNumber: string;
    /**
     * 
     * @type {number}
     * @memberof AvailabilityByProduct
     */
    totalQuantity: number;
    /**
     * 
     * @type {number}
     * @memberof AvailabilityByProduct
     */
    totalAmount: number;
}

/**
 * Check if a given object implements the AvailabilityByProduct interface.
 */
export function instanceOfAvailabilityByProduct(value: object): value is AvailabilityByProduct {
    if (!('productNumber' in value) || value['productNumber'] === undefined) return false;
    if (!('totalQuantity' in value) || value['totalQuantity'] === undefined) return false;
    if (!('totalAmount' in value) || value['totalAmount'] === undefined) return false;
    return true;
}

export function AvailabilityByProductFromJSON(json: any): AvailabilityByProduct {
    return AvailabilityByProductFromJSONTyped(json, false);
}

export function AvailabilityByProductFromJSONTyped(json: any, ignoreDiscriminator: boolean): AvailabilityByProduct {
    if (json == null) {
        return json;
    }
    return {
        
        'productNumber': json['productNumber'],
        'totalQuantity': json['totalQuantity'],
        'totalAmount': json['totalAmount'],
    };
}

export function AvailabilityByProductToJSON(json: any): AvailabilityByProduct {
    return AvailabilityByProductToJSONTyped(json, false);
}

export function AvailabilityByProductToJSONTyped(value?: AvailabilityByProduct | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'productNumber': value['productNumber'],
        'totalQuantity': value['totalQuantity'],
        'totalAmount': value['totalAmount'],
    };
}

